import { router } from 'expo-router'

export const changeSearchOpen = (opened: boolean): void =>
    router.setParams({ searchOpen: opened ? 'true' : undefined })
